module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.communities) ? _c('community-list-table') : _vm._e(), _vm._v(" "), _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.communityListPageCount > 1),
      expression: "communityListPageCount > 1"
    }]
  }, [_c('paginate', {
    ref: "communityListPaginate",
    attrs: {
      "pageCount": _vm.communityListPageCount,
      "initial-page": 0,
      "clickHandler": _vm.communityListPaginate,
      "container-class": 'pagination justify-content-center',
      "page-class": 'page-item',
      "page-link-class": 'page-link',
      "prev-class": 'page-item',
      "prev-link-class": 'page-link',
      "next-class": 'page-item',
      "next-link-class": 'page-link'
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loggedIn),
      expression: "loggedIn"
    }],
    staticClass: "text-center"
  }, [_c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "tag": "button",
      "type": "button",
      "to": {
        name: 'communityCreator'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.create.community')) + "\n    ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-4 text-center"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('community.list.search')))]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "description": _vm.$t('community.list.search.description')
    }
  }, [_c('typeahead', {
    ref: "communitySearchTypeahead",
    attrs: {
      "action": "searchCommunities",
      "actionIndicator": "searchingCommunities",
      "onHit": _vm.communitySelected
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ae8e371"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommunityList.vue
// module id = 470
// module chunks = 0